import { Link } from 'react-router-dom';

const footerLinks = {
  explore: [
    { label: '动作电影', to: '/category/action' },
    { label: '喜剧电影', to: '/category/comedy' },
    { label: '科幻电影', to: '/category/scifi' },
    { label: '剧情电影', to: '/category/drama' },
    { label: '热播剧集', to: '/category/all' },
  ],
  about: [
    { label: '关于我们', to: '/about' },
    { label: '品牌故事', to: '/about' },
    { label: '用户口碑', to: '/about' },
    { label: '联系我们', to: '/about' },
  ],
  support: [
    { label: '常见问题', to: '/about' },
    { label: '播放帮助', to: '/about' },
    { label: '版权声明', to: '/about' },
    { label: '隐私政策', to: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800/50">
      <div className="w-full px-4 md:px-6">
        <div className="py-10 md:py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-fill text-primary-500 text-2xl"></i>
                </div>
                <span className="font-heading text-xl font-bold text-foreground-50">星空影院</span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-xs">
                星空影院在线观看免费，为您提供海量高清电影、热播剧集和精彩综艺。无需注册、无需付费，随时随地畅享优质影视内容。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
                <a href="#explore" className="hover:text-primary-500 transition-colors duration-200">探索内容</a>
              </h4>
              <ul className="space-y-2.5">
                {footerLinks.explore.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
                <a href="#about-us" className="hover:text-primary-500 transition-colors duration-200">关于星空</a>
              </h4>
              <ul className="space-y-2.5">
                {footerLinks.about.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
                <a href="#support" className="hover:text-primary-500 transition-colors duration-200">帮助支持</a>
              </h4>
              <ul className="space-y-2.5">
                {footerLinks.support.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600">
              &copy; {new Date().getFullYear()} 星空影院 xingkongcinema.com — 星空影院在线观看免费，高清电影免费看
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800/60 hover:bg-primary-500/20 transition-all duration-300 group" aria-label="微信">
                <i className="ri-wechat-line text-foreground-500 group-hover:text-primary-500 transition-colors duration-300 text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800/60 hover:bg-primary-500/20 transition-all duration-300 group" aria-label="微博">
                <i className="ri-weibo-line text-foreground-500 group-hover:text-primary-500 transition-colors duration-300 text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800/60 hover:bg-primary-500/20 transition-all duration-300 group" aria-label="抖音">
                <i className="ri-tiktok-line text-foreground-500 group-hover:text-primary-500 transition-colors duration-300 text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}